var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRepeatRequests = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9917 4.99996L12.6584 3.33329L10.9917 1.66663",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0085 15L8.3418 16.6667L10.0085 18.3333",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2287 5.30908C16.4245 6.51408 17.167 8.16825 17.167 9.99992C17.167 13.6816 14.182 16.6666 10.5004 16.6666C9.84538 16.6666 9.21454 16.5682 8.61621 16.3924",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71183 14.6349C4.55016 13.4349 3.8335 11.8016 3.8335 9.99992C3.8335 6.31825 6.8185 3.33325 10.5002 3.33325C11.1552 3.33325 11.786 3.43159 12.3843 3.60742",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRepeatRequests, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/repeatRequests.d788a376.svg";
export { ForwardRef as ReactComponent };